const fetchFromApi = async (data) => {
    let key = process.env.NEXT_PUBLIC_OPENAI_SECRET
    let json
    try {
        await fetch("https://api.openai.com/v1/engines/text-davinci-002/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                // "Authorization": `Bearer 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`,
                "Authorization": `Bearer ${key}`,
            },
            body: JSON.stringify(data),
        })
            .then(res => {
                if (res.ok) return json = res.json()
                throw new Error('Error in fetch')
            })
        return json
    } catch (e) {
        console.error(e)
        return new Error('NO DATA TO PROCESS')
    }

}

export default fetchFromApi